import {userConstants} from '../_constants';

export function warehouseUserGoods(state = {}, action) {
  switch (action.type) {
    case userConstants.WAREHOUSEMAN_USER_GOODS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userConstants.WAREHOUSEMAN_USER_GOODS_SUCCESS:
      return {
        ...state,
        ...action.data,
        loading: false,
      };
    case userConstants.WAREHOUSEMAN_USER_GOODS_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}